import { PayeeTotals } from "../../../../settlement/src/driver-settlement/PayeeTotals";
import { OfficePayrollProcessingGroupBy } from "../OfficePayrollProcessingGroupBy";
import { OfficePayrollProcessingPayeeDetail } from "../OfficePayrollProcessingPayeeDetail";
import { Button, DataSource, Layout, LayoutHeader, Panel, Splitter, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayrollProcessing extends Layout {
    buttonArchiveVoids: Button;
    buttonManageRecurring: Button;
    buttonProcess: Button;
    buttonTimecardProcessing: Button;
    layoutGroupBy: OfficePayrollProcessingGroupBy;
    layoutOfficePayrollProcessingPayeeDetail: OfficePayrollProcessingPayeeDetail;
    layoutPayeeTotals: PayeeTotals;
    layoutheaderOfficePayrollProcessing: LayoutHeader;
    panelContent: Panel;
    sourceOfficePayrollProfile: DataSource;
    sourceOrderPayablesCache: DataSource;
    sourcePayeeCache: DataSource;
    sourceStateFederalTaxDriverSettlement: DataSource;
    sourceTimecard: DataSource;
    sourceVoidedPayablesOfficePayroll: DataSource;
    splitterOfficePayrollProcessing: Splitter;
    textboxOverrideCutoffDate: Textbox;
    textboxPayrollCutoffDate: Textbox;
}
